export const isMalformedGojsModel = (gojsModel?: DefaultGoJSModel | null) => {
  if (!gojsModel) {
    return false;
  }

  if (!gojsModel['linkFromPortIdProperty'] || !gojsModel['linkToPortIdProperty']) {
    return true;
  }

  return false;
};

interface DefaultGoJSModel {
  class: string;
  linkFromPortIdProperty?: string;
  linkToPortIdProperty?: string;
  nodeDataArray: unknown[];
  linkDataArray: unknown[];
}

export const defaultGojsModel = (): DefaultGoJSModel => ({
  class: 'go.GraphLinksModel',
  linkFromPortIdProperty: 'frompid',
  linkToPortIdProperty: 'topid',
  nodeDataArray: [],
  linkDataArray: [],
});
